import { ModalHandler } from '../Modal';
import { ModalContent } from './components/ModalContent';

export const ACTION_CONFIRMATION_MODAL = 'action-confirmation';

export const ActionConfirmationModal = () => {
  return (
    <ModalHandler id={ACTION_CONFIRMATION_MODAL} channel="system">
      <ModalContent />
    </ModalHandler>
  );
};
